import {
  List,
  ListItem,
  Checkbox,
  Box,
  ListItemIcon,
  ListItemText,
  Icon,
  TextField as MuiTextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  makeStyles,
  ListItemSecondaryAction,
  IconButton,
  Chip,
} from "@material-ui/core";
import {
  UnfoldMoreRounded,
  CloseRounded,
  SearchRounded,
  WorkOutlineRounded,
} from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { memo, useContext, useEffect, useRef, useState } from "react";
import DoctorIcon from "../icons/doctor-icon";
import { useZonesSelection } from "../hooks/useZoneSelection";
import { laboratoryServices } from "../services";
import { AuthContext } from "../context";
export function ZoneAssignmentList({ children }) {
  return (
    <List style={{ maxHeight: "62vh", overflowY: "auto" }}>{children}</List>
  );
}

export const UserListItem = memo((props) => {
  const {
    id,
    userType,
    primaryText,
    secondaryText,
    onHandleChange,
    dataZones,
    updateAssignments,
    userZones,
    checked,
    disabled,
    ...rest
  } = props;
  const [userChecked, setUserChecked] = useState(checked);
  const firstChecked = useRef(true);
  const { selectedZones } = useZonesSelection();
  const [userSelectedZones, setUserSeletedZones] = useState([]);
  const { authState, signOut } = useContext(AuthContext);

  const cls = userListItemStyles();
  const handleChange = (e) => {
    const checked = e.target.checked;
    setUserChecked(checked);
    if (firstChecked.current) {
      setUserSeletedZones(selectedZones);
      onHandleChange(checked, userType, {
        _id: id,
        zones: selectedZones.map((z) => z._id),
      });
      firstChecked.current = false;
      return;
    }
    onHandleChange(checked, userType, {
      _id: id,
      zones: userSelectedZones.map((z) => z._id),
    });
  };

  const addZoneToUserSelectedZones = (e, zoneToAdd, reason) => {
    if (reason === "select-option") {
      setUserSeletedZones((prev) => {
        const data = prev.find((prevZone) => prevZone._id === zoneToAdd._id)
          ? prev
          : [...prev, { name: zoneToAdd.name, _id: zoneToAdd._id }];
        updateAssignments(userType, {
          _id: id,
          zones: data.map((zone) => zone._id),
        });
        return data;
      });
    }
  };
  // useEffect(() => {
  //   console.log({ userSelectedZones });
  // }, [userSelectedZones]);
  return (
    <ListItem
      className={cls.user_list_item}
      data-status={userChecked ? "checked" : "unchecked"}
      {...(disabled && {
        style: {
          pointerEvents: "none",
          filter: "contrast(0.9) grayscale(1) opacity(0.7)",
        },
      })}
      {...rest}
    >
      <Box className={cls.user_list_item_header}>
        <ListItemIcon>
          <Checkbox
            color="primary"
            checked={userChecked}
            onChange={handleChange}
            disableRipple
            inputProps={{ "aria-labelledby": "labelId" }}
          />
        </ListItemIcon>
        <ListItemIcon style={{ justifyContent: "end" }}>
          {userType === "doctors" ? (
            <Box display="flex" style={{ gap: 8, alignItems: "center" }}>
              <Typography color="textSecondary">Doctor</Typography>
              <Icon className={cls.user_list_icon}>
                <DoctorIcon />
              </Icon>
            </Box>
          ) : (
            <Box display="flex" style={{ gap: 8, alignItems: "center" }}>
              <Typography color="textSecondary">Representantes</Typography>
              <Icon
                className={cls.user_list_icon}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <WorkOutlineRounded />
              </Icon>
            </Box>
          )}
        </ListItemIcon>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        width={"100%"}
      >
        <ListItemText
          id={"labelId"}
          primary={primaryText}
          secondary={secondaryText}
          className={cls.user_list_item_data}
        />
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          width={"100%"}
          style={{ gap: 4 }}
        >
          <Typography variant="body2" style={{ textAlign: "center" }}>
            Zonas asignadas
          </Typography>
          {userZones.length > 0 ? (
            <Box display={"flex"} flexWrap={"wrap"} style={{ gap: 8 }}>
              {userZones.map((zone) => (
                <Chip
                  style={{ backgroundColor: "#2196c03d" }}
                  key={`chip-zone-user${id}-zone-${zone.visitingZoneInfo._id}`}
                  label={zone.visitingZoneInfo.name}
                />
              ))}
            </Box>
          ) : (
            <Typography variant="caption" color="primary">
              No tiene zonas asignadas
            </Typography>
          )}
        </Box>
      </Box>
      {userChecked && (
        <Box className={cls.user_list_item_container_inner_list}>
          <Accordion defaultExpanded className={cls.user_list_item_accordion}>
            <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
              expandIcon={<UnfoldMoreRounded color="primary" />}
            >
              <Typography color="textPrimary">Zonas por asignar </Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{ padding: "0px 12px 0px", flexDirection: "column" }}
            >
              <List dense style={{ width: "100%", padding: 0 }}>
                {userSelectedZones.map((userselectedZone) => (
                  <ListItemWithAction
                    key={`user-${id}-id-zone${userselectedZone._id}`}
                    zone={userselectedZone}
                    onDeleteUserSelectedZone={(_id) => {
                      setUserSeletedZones((prevZones) => {
                        const data = prevZones.filter((z) => z._id !== _id);
                        updateAssignments(userType, {
                          _id: id,
                          zones: data.map((zone) => zone._id),
                        });
                        return data;
                      });
                    }}
                  />
                ))}
              </List>
              <Autocomplete
                id="select-new-zone"
                onChange={addZoneToUserSelectedZones}
                options={dataZones}
                getOptionLabel={(opt) => opt.name}
                fullWidth
                clearOnBlur
                clearOnEscape
                style={{ marginTop: 16, marginBottom: 12 }}
                popupIcon={<SearchRounded color="primary" />}
                renderInput={(params) => (
                  <MuiTextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Añadir nueva zona"
                    className={cls.text_field_autocomplete}
                  />
                )}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </ListItem>
  );
});

const userListItemStyles = makeStyles((theme) => ({
  user_list_item: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexDirection: "column",
    '&[data-status="checked"]': {
      backgroundColor: `hsl(from ${theme.palette.secondary.main} h s calc(l + 52))`,
    },
  },
  user_list_item_header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  user_list_icon: {
    border: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    borderRadius: "100%",
    fontSize: "2rem",
  },
  user_list_item_data: {
    margin: 0,
    marginBottom: theme.spacing(3),
  },
  user_list_item_container_inner_list: {
    alignSelf: "stretch",
    margin: 0,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  user_list_item_accordion: {
    backgroundColor: `hsl(from ${theme.palette.secondary.main} h s calc(l + 55))`,
    boxShadow: `-2px 0 0 0 ${`hsl(from ${theme.palette.primary.light} h s calc(l + 30))`}`,
  },
  text_field_autocomplete: {
    "& .MuiInputBase-root": {
      borderRadius: theme.spacing(2),
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: `hsl(from ${theme.palette.primary.light} h s calc(l + 30))`,
      backgroundColor: theme.palette.background.paper,
      "& .MuiInputBase-input::placeholder": {
        color: `hsl(from ${theme.palette.primary.light} h s calc(l + 10))`,
        opacity: "1",
      },
      "& .MuiAutocomplete-popupIndicatorOpen": {
        transform: "none !important", // evita la rotación
      },
    },
    "& fieldset": {
      borderColor: "transparent !important",
    },
  },
}));

export const ListItemWithAction = memo((props) => {
  const { zone, onDeleteUserSelectedZone } = props;
  const cls = listItemWithActionStyles();
  return (
    <ListItem className={cls.custom_list_item}>
      <ListItemText style={{ textTransform: "capitalize" }}>
        {zone.name}
      </ListItemText>
      <ListItemSecondaryAction>
        <IconButton
          style={{ borderRadius: "none" }}
          onClick={() => onDeleteUserSelectedZone(zone._id)}
        >
          <CloseRounded fontSize="small" />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
});

const listItemWithActionStyles = makeStyles((theme) => ({
  custom_list_item: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: "none",
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
  },
}));
